import { render, staticRenderFns } from "./edit_info.vue?vue&type=template&id=425a1279&scoped=true&"
import script from "./edit_info.vue?vue&type=script&lang=js&"
export * from "./edit_info.vue?vue&type=script&lang=js&"
import style0 from "./edit_info.vue?vue&type=style&index=0&id=425a1279&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425a1279",
  null
  
)

export default component.exports